<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            max-width="800"
            persistent
        >
            <v-tabs
                slider-color="grey"
                v-model="tab"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab ripple>Transaction</v-tab>
                <v-tab ripple v-if="actions">Actions</v-tab>
                <v-tab v-if="role <= 3" ripple>Payload</v-tab>

                <!-- Transactions -->
                <v-tab-item>
                    <v-card class="pt-2">
                        <v-card-text v-if="'resultDetails' in info && 'AcquirerResponse' in info.resultDetails" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Acquirer Response:</span> {{ info.resultDetails.AcquirerResponse }}</v-card-text>
                        <v-card-text v-if="info.amount" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Amount:</span> {{ Number(info.amount).toFixed(2) }}</v-card-text>
                        <v-card-text v-if="'result' in info && 'avsResponse' in info.result" class="py-0"><span class="font-weight-bold pr-5 json-key-title">AVS:</span> {{ info.result.avsResponse }}</v-card-text>
                        <v-card-text v-if="info.card.expiryMonth" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Card Expiry:</span> {{ info.card.expiryMonth }}/{{ info.card.expiryYear }}</v-card-text>
                        <v-card-text class="py-0"><span class="font-weight-bold pr-5 json-key-title">Card Holder:</span> {{ info.card.holder }}</v-card-text>
                        <v-card-text v-if="info.card.bin" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Card Number:</span> {{ `${info.card.bin}******${info.card.last4Digits}` }}</v-card-text>
                        <v-card-text v-if="info.card.type" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Card Type:</span> {{ cardType }}</v-card-text>
                        <v-card-text v-if="'customer' in info && 'companyName' in info.customer" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Company Name:</span> {{ info.customer.companyName }}</v-card-text>
                        <v-card-text v-if="binData && 'corporate' in binData" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Corporate:</span> {{ corpCheck }}</v-card-text>
                        <v-card-text v-if="'resultDetails' in info" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Clearing Institute:</span> {{ info.resultDetails.clearingInstituteName }}</v-card-text>
                        <v-card-text v-if="info.channelName" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Channel Name:</span> {{ info.channelName }}</v-card-text>
                        <v-card-text v-if="info.currency" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Currency:</span> {{ info.currency }}</v-card-text>
                        <v-card-text v-if="'customer' in info && 'email' in info.customer" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Customer Email:</span> {{ info.customer.email }}</v-card-text>
                        <v-card-text v-if="'resultDetails' in info && 'ExtendedDescription' in info.resultDetails" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Extended Description:</span> {{ info.resultDetails.ExtendedDescription }}</v-card-text>
                        <v-card-text v-if="'customer' in info && 'ip' in info.customer" class="py-0"><span class="font-weight-bold pr-5 json-key-title">IP Address:</span> {{ info.customer.ip }}</v-card-text>
                        <v-card-text v-if="'card' in info && 'issuer' in info.card && 'bank' in info.card.issuer" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Issuer:</span> {{ info.card.issuer.bank }}</v-card-text>
                        <v-card-text v-if="'card' in info && 'country' in info.card" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Issuer Country:</span> {{ info.card.country }}</v-card-text>
                        <v-card-text v-if="info.merchantInvoiceId" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Merchant Invoice ID:</span> {{ info.merchantInvoiceId }}</v-card-text>
                        <v-card-text v-if="info.merchantMemo" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Merchant Memo:</span> {{ info.merchantMemo }}</v-card-text>
                        <v-card-text v-if="info.merchantTransactionId" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Merchant Transaction ID:</span> {{ info.merchantTransactionId }}</v-card-text>
                        <v-card-text class="py-0"><span class="font-weight-bold pr-5 json-key-title">Processing Time:</span> {{ info.timestamp }}</v-card-text>
                        <v-card-text v-if="info.paymentType != 'SD' && info.paymentType != 'DS'" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Payment Brand:</span> {{ info.paymentBrand }}</v-card-text>
                        <v-card-text class="py-0"><span class="font-weight-bold pr-5 json-key-title">Payment Type:</span> {{ info.paymentType || 'RG' }}</v-card-text>
                        <v-card-text v-if="info.referencedId" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Reference ID:</span> {{ info.referencedId }}</v-card-text>
                        <v-card-text v-if="info.registrationId" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Registration ID:</span> {{ info.registrationId }}</v-card-text>
                        <v-card-text v-if="info.risk && info.risk.score" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Risk Score:</span> {{ info.risk.score }}</v-card-text>
                        <v-card-text v-if="info.descriptor" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Short ID:</span> {{ info.descriptor.substring(0, 14) }}</v-card-text>
                        <v-card-text v-if="scheduleDates" class="py-0"><span class="font-weight-bold pr-5 json-key-title">{{ scheduleDates[0].name }}:</span> {{ scheduleDates[0].date }}</v-card-text>
                        <v-card-text v-if="scheduleDates" class="py-0"><span class="font-weight-bold pr-5 json-key-title">{{ scheduleDates[1].name }}:</span> {{ scheduleDates[1].date }}</v-card-text>
                        <v-card-text v-if="scheduleDates && scheduleDates[2].name == 'Next Execution'" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Subsequent Execution:</span> {{ scheduleDates[2].date }}</v-card-text>
                        <v-card-text v-else-if="scheduleDates" class="py-0"><span class="font-weight-bold pr-5 json-key-title">{{ scheduleDates[2].name }}:</span> {{ scheduleDates[2].date }}</v-card-text>
                        <v-card-text v-if="'result' in info" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Status Code:</span> {{ info.result.code }}</v-card-text>
                        <v-card-text v-if="'result' in info" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Status Description:</span> {{ info.result.description }}</v-card-text>
                        <v-card-text v-if="'card' in info && 'result' in info.card" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Status Code:</span> {{ info.card.result.code }}</v-card-text>
                        <v-card-text v-if="'card' in info && 'result' in info.card" class="py-0"><span class="font-weight-bold pr-5 json-key-title">Status Description:</span> {{ info.card.result.description }}</v-card-text>
                        <v-card-text class="pt-0 pb-2"><span class="font-weight-bold pr-5 json-key-title">UUID:</span> {{ info.id }}</v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>

                <!-- Actions -->
                <v-tab-item
                    v-if="actions">
                    <v-card>
                        <v-container fluid>
                            <v-row>
                                <v-col md="3" class="py-0">
                                    <v-text-field
                                        type="number"
                                        v-model="amount"
                                        label="Amount"
                                        class="pb-0"
                                        :disabled="info.paymentType == 'SD'"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="response && response.result.code == '000.000.000'">
                                <v-col md="12" class="py-0">
                                    <v-alert
                                        type="success"
                                        text border="left"
                                        dismissible
                                        class="mb-2">
                                        Code: {{ response.result.code }}<br>
                                        Description: {{ response.result.description }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-else-if="response && response.result.code != '000.000.000'" class="px-4">
                                <v-col md="12" class="">
                                    <v-alert type="error" text border="left" dismissible>
                                        Code: {{ response.result.code }}<br>
                                        Description: {{ response.result.description }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="((info.paymentType == 'DB' || info.paymentType == 'CP') && brightSunPermsHigh)"
                                :disabled="!amount"
                                color="error"
                                @click="refund()"
                            >Refund</v-btn>
                            <v-btn
                                v-if="((info.paymentType == 'PA' || info.paymentType == 'CP')) && brightSunPermsHigh"
                                :disabled="!amount"
                                color="error"
                                @click="reversal()">
                            Reversal</v-btn>
                            <v-btn
                                v-if="(info.paymentType == 'PA')"
                                color="primary"
                                @click="capture()"
                            >Capture</v-btn>
                            <v-btn
                                v-if="(info.paymentType == 'SD')"
                                color="error"
                                @click="deschedule()"
                            >Deschedule</v-btn>
                            <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>

                <!-- Payload -->
                <v-tab-item v-if="role <= 3">
                    <v-card class="pt-2 pl-2 pr-2 caption">
                        <pre>{{ info }}</pre>
                        <v-divider class="mt-2"></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        visible: Boolean,
        state: Boolean,
        info: Object,
        binData: Object,
        scheduleDates: Array
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        actions(e) {
            if(this.info.paymentType == 'DB' ||
               this.info.paymentType == 'PA' ||
               this.info.paymentType == 'CP' ||
               this.info.paymentType == 'RB' ||
               this.info.paymentType == 'SD') {
                   if('result' in this.info && this.info.result.code == '000.000.000') {
                        return true;
                   }
                   else if('card' in this.info && 'result' in this.info.card && this.info.card.result.code == '000.000.000') {
                        return true;
                   }
                   else {
                       return false;
                   }
               }
            else {
                return false;
            }
        },
        upperCase() {
            return this.binData.brand.toLowerCase()
                       .split(' ')
                       .map((s) => s.charAt(0).toUpperCase() + s.substring(1)) 
                       .join(' ');
        },
        corpCheck() {
            return this.binData.corporate ? 'Yes' : 'No';
        },
        cardType() {
            var cardType = this.info.card.type; 
            return cardType == 'DEBIT' ? 'Debit Card' : cardType == 'CREDIT' ? 'Credit Card' : cardType;
        },
        brightSunPermsHigh() {
            if(this.role >= 4 && (this.merchantAccounts.includes("8ac9a4c8747f30650174968e8456706d") || this.merchantAccounts.includes("8acda4cb7401359d0174540973c84c4d"))) {
                if(this.role <= 5) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        },
        brightSunPermsMid() {
            if(this.role >= 4 (this.merchantAccounts.includes("8ac9a4c8747f30650174968e8456706d") || this.merchantAccounts.includes("8acda4cb7401359d0174540973c84c4d"))) {
                if(this.role <= 6) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    },
    beforeMount() {
        if(this.amount) {
            this.amount = Number(this.info.amount).toFixed(2);
        }
        this.role = this.$store.getters.role;
        if(![1, 2, 3].includes(this.$store.state.user.user_role.id)) {
            this.merchantAccounts = this.$store.state.user.merchant_access.replace(/"/g, '').replace('[', '').replace(']', '').split(',');
        }
    },
    data() {
        return {
            tab: null,
            data: null,
            response: null,
            uri: this.state ? 'live' : 'test',
            amount: null,
            role: null,
            merchantAccounts: null
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close', false);
        },
        refund() {
            axios({
                method: 'post',
                url: `refund-${this.uri}`,
                data: { amount: this.amount,
                        currency: this.info.currency,
                        uuid: this.info.id,
                        channelUuid: this.info.authentication.entityId,
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.response = response.data;
                    this.amount = null;
                    setTimeout(() => {
                        this.$emit('getTransactions');
                    }, 2000);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        reversal() {
            axios({
                method: 'post',
                url: `reversal-${this.uri}`,
                data: { amount: this.amount,
                        currency: this.info.currency,
                        uuid: this.info.id,
                        channelUuid: this.info.authentication.entityId,
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.response = response.data;
                    this.amount = null;
                    setTimeout(() => {
                        this.$emit('getTransactions');
                    }, 2000);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        capture() {
            axios({
                method: 'post',
                url: `capture-${this.uri}`,
                data: { amount: this.amount,
                        currency: this.info.currency,
                        uuid: this.info.id,
                        channelUuid: this.info.authentication.entityId,
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.response = response.data;
                    this.amount = null;
                    setTimeout(() => {
                        this.$emit('getTransactions');
                    }, 2000);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        deschedule() {
            axios({
                method: 'post',
                url: `deschedule-${this.uri}`,
                data: { uuid: this.info.id,
                        channelUuid: this.info.authentication.entityId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.response = response.data;
                    setTimeout(() => {
                        this.$emit('getTransactions');
                    }, 2000);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>
    .json-key-title {
        display: inline-flex;
        width: 200px;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>